import { PDFDocument } from "pdf-lib";

export const constructFormData_toPDF = async (
    path , 
    fieldSignatories,
    mainValues,
    agentValues
) => {

    const PDF_FILE = path

    if (!PDF_FILE) {
        // dispatch(setAlert({
        //     show: true,
        //     title: 'Template Error',
        //     body: 'No existing PDF Template.',
        // }))
        return "No existing PDF Template.";
    }

    try {
        // Load the PDF document
        const formPdfBytes = await fetch(PDF_FILE).then(res => res.arrayBuffer())
        const pdfDoc = await PDFDocument.load(formPdfBytes);
        //get Form Fields
        const form = pdfDoc.getForm();

        const fields = form.getFields()
        fields.forEach(async (field) => {
            const fieldName = field.getName()

            if (mainValues?.hasOwnProperty(fieldName) ||
                agentValues?.hasOwnProperty(fieldName) ||
                fieldSignatories?.hasOwnProperty(fieldName)
            ) {

                const formFieldValue = (mainValues[fieldName]) && mainValues[fieldName]?.toString();
                const agentFieldValue = (agentValues[fieldName]) && agentValues[fieldName]?.toString();
                const fieldImg = (fieldSignatories[fieldName]) && fieldSignatories[fieldName];

                if (
                    !(field.constructor.name === "PDFRadioGroup") &&
                    !(field.constructor.name === "PDFCheckBox" &&
                    !(field.constructor.name === "PDFButton"))
                ) {
                    if(agentFieldValue){
                        form.getTextField(fieldName).setText(agentFieldValue) //Agent
                    }else{
                        form.getTextField(fieldName).setText(formFieldValue) //Forms
                    }

                    if(fieldName.includes("SignedDate")){
                        form.getTextField(fieldName).setText(fieldSignatories[fieldName]) //signatory date
                    }

                    if (fieldImg && fieldName.includes("Signature")) {
                        const sigField = form.getTextField(fieldName)
                        // const image = await fetch(fieldImg).then(res => res.arrayBuffer())
                        const embededImg = await pdfDoc.embedPng(fieldImg) //Signatories
                        sigField.setImage(embededImg)
                    }
                }

            // disable filled out fields.
                field?.enableReadOnly()

            }
        })

        // Serialize the PDFDocument to bytes
        const pdfBytes = await pdfDoc.save();
        // const pdfBytesAsBase64 = await pdfDoc.saveAsBase64({ dataUri: true });
        // const fileName = file?.FormName
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        return blob;
    } catch (error) {
        throw(error)
        // console.log(error)
        // dispatch(setAlert({
        //     show: true,
        //     title: ALERT_TYPE.ERROR,
        //     body: 'Error downloading the PDF.',
        // }))
    }
}

export const downloadBlobFile = async (blob , fileName) => {
     // Create a blob and a link element
     const url = URL.createObjectURL(blob);
     const link = document.createElement('a');
     link.href = url;
     link.download = `${fileName}`; // Specify the default file name

     // Append the link to the body (not visible)
     document.body.appendChild(link);
     // Programmatically click the link to trigger the download
     link.click();
     // Clean up by removing the link element and revoking the Blob URL
     document.body.removeChild(link);
     URL.revokeObjectURL(url);
}

export const downloadFileByURL = async (fileURL , fileName) => {
     // Create a blob and a link element

     const link = document.createElement('a');
     link.href = fileURL;
     link.download = `${fileName}`; // Specify the default file name
     // Append the link to the body (not visible)
     document.body.appendChild(link);
     // Programmatically click the link to trigger the download
     link.click();
     // Clean up by removing the link element and revoking the Blob URL
     document.body.removeChild(link);
}

export const viewPDFFile = async (blob) => {
    // Create a blob and a URL for it
    const url = URL.createObjectURL(blob, '_blank');

    // Open the Blob URL in a new tab
    window.open(`${url}#toolbar=0&navpanes=0&scrollbar=0`, '_blank', 'width=800,height=800');
    // Optional: Clean up the Blob URL after a short delay
    setTimeout(() => {
        URL.revokeObjectURL(url);
    }, 1000); // Adjust the timeout as needed
}

 

export const validateFile = (file) => {
    let valid = true;
    let errMsg = ''
    const maxSize = 100 * 1024 * 1024; // 100 MB in bytes

    const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
    const validDocTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    const validExcelTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    
    
    if (file?.size > maxSize) {
        return {
            valid: false,
            errMsg: "The file is too large. Maximum allowed size is 100MB."
        }
    }
    if (file?.type === 'application/pdf' || file.type.includes('pdf')) {
        return {
            valid: true,
            errMsg: ""
        }
    }
    if (validDocTypes.includes(file.type)) {
        // Valid DOC/DOCX
        return { valid: true, errMsg: "" };
    }
    if (validImageTypes.includes(file.type)) {
        // Valid Image
        return { valid: true, errMsg: "" };
    }
    if (validExcelTypes.includes(file.type)) {
        return { valid: true, errMsg: "" };
    }

    return {
        valid: false,
        errMsg: "Invalid file format. Please select a valid file."
    }
}

export const base64ToBlob = (base64, mimeType) => {
    try {
        // Clean the base64 string
        const cleanedBase64 = cleanBase64(base64);

        // Check if cleanedBase64 length is valid
        if (cleanedBase64.length % 4 !== 0) {
            throw new Error('Invalid Base64 string');
        }

        // Decode base64 to binary
        const byteChars = atob(cleanedBase64);
        const byteArrays = [];

        for (let offset = 0; offset < byteChars.length; offset += 512) {
            const slice = byteChars.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            byteArrays.push(new Uint8Array(byteNumbers));
        }

        return new Blob(byteArrays, { type: mimeType });
    } catch (e) {
        console.error('Error decoding Base64 string:', e);
        throw e;
    }
};

const cleanBase64 = (base64) => {
    // Remove data URL scheme (if any)
    const base64Data = base64.replace(/^data:.+;base64,/, '');
    // Remove any whitespace characters (including newlines)
    return base64Data.replace(/[\s]/g, '');
};


export const findTemplate = (file , allPDFTemplates) => {
    const PUBLIC_FOLDER = process.env.PUBLIC_URL;
    const template = allPDFTemplates.find(form => form.Id === file.Id)
    return template.LocalPath ? PUBLIC_FOLDER + template.LocalPath : ""
}